import CoreBase from '../../../services/engines/CoreBase';
import gatewayService from '../../../services/GatewayService';
import responseHelper from '../../../services/ResponseHelper';
import csCodeGenConfigCache from './CsCodeGenConfigCache';

const _name = 'CsCodeGenConfigFetcher';
const TOPIC = 'Jerny.CsCodeGenConfigs';
const PAGE_SIZE = 50;

class CsCodeGenConfigFetcher extends CoreBase {
    /**
     * Fetches all entries for the CsCodeGenConfigs topic.
     * @returns {object[]|null}
     */
    fetch = async () => {
        try {
            const resp = await gatewayService.getUserEntries(TOPIC, 1, PAGE_SIZE);
            if (responseHelper.check(resp, '', `${_name}.fetch`) < 0) {
                this.logError('fetch', `code: ${resp?.status}`);
                return [];
            }

            let items = resp.data.items ?? [];

            items = items.filter((x) => x.stateId !== 999 && x.type === 'CsCodeGenConfig');

            csCodeGenConfigCache.setCache(items);
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };
}

const csCodeGenConfigFetcher = new CsCodeGenConfigFetcher();
export default csCodeGenConfigFetcher;
